export const NOTICES_GET_REQUEST = 'notices/GET_REQUEST';
export const NOTICES_GET_SUCCESS = 'notices/GET_SUCCESS';
export const NOTICES_GET_ERROR = 'notices/GET_ERROR';
